/**
 * TtfLocaTable.ts class for EJ2-PDF
 */
var TtfLocaTable = /** @class */ (function () {
    function TtfLocaTable() {
    }
    return TtfLocaTable;
}());
export { TtfLocaTable };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-pdf-export/src/implementation/graphics/fonts/ttf-loca-table.js
// module id = 1123
// module chunks = 0